import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../context/AuthContext';

const ImpersonationBanner = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { isImpersonating, impersonatedSalonName, endImpersonation } = useAuth();

  if (!isImpersonating) return null;

  const handleExit = () => {
    endImpersonation();
    navigate('/admin/dashboard');
  };

  return (
    <div className="flex items-center justify-between bg-amber-500/20 px-6 py-2 text-sm text-amber-200">
      <span>
        {t('impersonation.viewingAs', { salonName: impersonatedSalonName })}{' '}
        <button type="button" onClick={handleExit} className="underline hover:text-zinc-900 dark:hover:text-white">
          {t('impersonation.exit')}
        </button>
      </span>
    </div>
  );
};

export default ImpersonationBanner;
